export const manifest = {
  screens: {
    scr_622yrg: { name: "Inicio", route: "/", position: {"x":160,"y":220} },
    scr_f7i7ue: { name: "Inversiones", route: "/inversiones", position: {"x":1560,"y":220} },
  },
  sections: {
    sec_gkxp19: { name: "Main Navigation", x: 0, y: 0, width: 2920, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_gkxp19", children: [
      { kind: "screen", id: "scr_622yrg" },
      { kind: "screen", id: "scr_f7i7ue" },
    ] },
  ],
}
